import Skeleton from 'react-loading-skeleton';
import React, { useContext } from 'react';
import { ThemeContext } from '@/theme/ThemeProvider';

interface OrderBookSkeletonProps {
  loading: boolean;
  children: React.ReactNode;
}

const OrderBookSkeleton = ({ loading, children }: OrderBookSkeletonProps) => {
  const { isDarkMode } = useContext(ThemeContext);

  // 다크모드/라이트모드별 스켈레톤 색상
  const baseColor = isDarkMode ? '#1a1a1a' : '#ebebeb';
  const highlightColor = isDarkMode ? '#2a2a2a' : '#f5f5f5';

  if (!loading) return <>{children}</>;

  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
        padding: 4,
      }}
    >
      <Skeleton height={25} borderRadius={4} baseColor={baseColor} highlightColor={highlightColor} />
      <Skeleton height={25} borderRadius={4} baseColor={baseColor} highlightColor={highlightColor} />
      <Skeleton height={25} borderRadius={4} baseColor={baseColor} highlightColor={highlightColor} />
      <Skeleton height={25} borderRadius={4} baseColor={baseColor} highlightColor={highlightColor} />
      <Skeleton height={25} borderRadius={4} baseColor={baseColor} highlightColor={highlightColor} />
      <Skeleton height={25} borderRadius={4} baseColor={baseColor} highlightColor={highlightColor} />
      <Skeleton height={25} borderRadius={4} baseColor={baseColor} highlightColor={highlightColor} />
      <Skeleton height={25} borderRadius={4} baseColor={baseColor} highlightColor={highlightColor} />
      <Skeleton height={50} borderRadius={4} baseColor={baseColor} highlightColor={highlightColor} />
      <Skeleton height={25} borderRadius={4} baseColor={baseColor} highlightColor={highlightColor} />
      <Skeleton height={25} borderRadius={4} baseColor={baseColor} highlightColor={highlightColor} />
      <Skeleton height={25} borderRadius={4} baseColor={baseColor} highlightColor={highlightColor} />
      <Skeleton height={25} borderRadius={4} baseColor={baseColor} highlightColor={highlightColor} />
      <Skeleton height={25} borderRadius={4} baseColor={baseColor} highlightColor={highlightColor} />
      <Skeleton height={25} borderRadius={4} baseColor={baseColor} highlightColor={highlightColor} />
      <Skeleton height={25} borderRadius={4} baseColor={baseColor} highlightColor={highlightColor} />
      <Skeleton height={25} borderRadius={4} baseColor={baseColor} highlightColor={highlightColor} />
    </div>
  );
};

export default OrderBookSkeleton;
